import React, { useState, useMemo } from 'react'
import '../../styles/css/Sidebar.css'
import { NavLink, useLocation, useNavigate } from 'react-router-dom'
import LogoSidebar from './LogoSidebar'
import dashboardLogoGrey from '../../assets/icons/dashboard-icon-grey.svg'
import kehadiranLogoGrey from '../../assets/icons/kehadiran-icon-grey.svg'
import karyawanLogoGrey from '../../assets/icons/karyawan-icon-grey.svg'
import kalenderLogoGrey from '../../assets/icons/kalender-icon-grey.svg'
import siswaLogoGrey from '../../assets/icons/siswa.svg'
import jurnalLogoGrey from '../../assets/icons/jurnal.svg'
import jadwalLogoGrey from '../../assets/icons/jadwal.svg'
import loginLogoGrey from '../../assets/icons/logout-icon-grey.svg'
import buatSoalLogoGrey from '../../assets/icons/buat-soal-icon-grey.svg'
import monitorLogoGrey from '../../assets/icons/monitor-icon-grey.svg'
import walikelasLogoGrey from '../../assets/icons/reassign.svg'
import penilaianLogoGrey from '../../assets/icons/penilian-guru-icon-grey.svg'
import siswaHistoryAttedance from '../../assets/icons/siswa-history-attedance.svg'
import studentsJoorunal from '../../assets/icons/students-journal.svg'
import axios from 'axios'
import LoadingFullscreen from '../LoadingFullscreen'
import apiUrl from '../../utils/apiUrl'
import { useApiProfile } from '../../contexts/api/ApiProfile'

function Sidebar() {
    const location = useLocation()
    const token = localStorage.getItem('token')
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const { profileData, loading: loadingProfile } = useApiProfile()

    // Semua menu dasar
    const dataSidebar = [
        { id: 1, path: '/', img: dashboardLogoGrey, text: 'Dashboard' },
        { id: 2, path: '/monitorkelas', img: monitorLogoGrey, text: 'Monitor Kelas' },
        { id: 3, path: '/penilaianguru', img: buatSoalLogoGrey, text: 'Penilaian Guru' },
        { id: 4, path: '/buatsoal', img: penilaianLogoGrey, text: 'Buat Soal' },
        { id: 5, path: '/kehadiransiswa', img: siswaHistoryAttedance, text: 'Kehadiran Siswa' },
        { id: 6, path: '/jurnalsiswa', img: studentsJoorunal, text: 'Jurnal Siswa' },
        { id: 7, path: '/kehadiran', tabbarPath: '/kehadiran/Masuk', img: kehadiranLogoGrey, text: 'Kehadiran' },
        { id: 8, path: '/karyawan', tabbarPath: `/karyawan/`, img: karyawanLogoGrey, text: 'Karyawan' },
        { id: 9, path: '/jurnalguru', img: jurnalLogoGrey, text: 'Jurnal Guru' },
        { id: 10, path: '/kalender', img: kalenderLogoGrey, text: 'Kalender' },
        { id: 11, path: '/jadwalguru', img: jadwalLogoGrey, text: 'Jadwal Guru' },
        { id: 12, path: '/siswa', img: siswaLogoGrey, text: 'Siswa' },
        { id: 13, path: '/wali-kelas', img: walikelasLogoGrey, text: 'Wali Kelas' },
        { id: 14, path: 'logout', img: loginLogoGrey, text: 'Logout' },

    ]

    // 🚀 Gunakan useMemo agar tidak re-render terus
    const filteredSidebar = useMemo(() => {
        if (!profileData || !profileData.ktgkaryawan) return dataSidebar

        const isKepegawaian = profileData.ktgkaryawan.some(
            item => item.kategori === 'Kepegawaian'
        )

        const isKurikulum = profileData.ktgkaryawan.some(
            item => item.kategori === 'Kurikulum'
        )



   if (profileData.walikelas != null){
            return dataSidebar.filter(
                item => ['Kehadiran Siswa', 'Jurnal Siswa','Logout'].includes(item.text)
            )
        }else if (isKepegawaian) {
            // Sembunyikan menu yang bukan tugas kepegawaian
            return dataSidebar.filter(
                item => !['Jadwal Guru', 'Jurnal Guru', 'Siswa'].includes(item.text)
            )
        } else if (isKurikulum) {
            // Hanya tampilkan menu untuk kurikulum
            return dataSidebar.filter(
                item => ['Jadwal Guru', 'Jurnal Guru', 'Siswa','Monitor Kelas','Penilaian Guru','Buat Soal','Wali Kelas', 'Logout'].includes(item.text)
            )
        }

        // Default (semua muncul) kalau belum punya kategori
        return dataSidebar.filter(
            item => !['Kehadiran Siswa', 'Jurnal Siswa'].includes(item.text)
        )
    }, [profileData])

    if (location.pathname === '/login') return null

    const logoutHanlder = async () => {
        setLoading(true)
        try {
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
            const url = apiUrl + '/api/logout'
            await axios.get(url)
            localStorage.removeItem('token')
            navigate('/login')
        } catch (error) {
            console.error('Logout failed:', error)
        } finally {
            setLoading(false)
        }
    }




    const isActiveRoute = (path) => {
        return location.pathname === path || location.pathname.startsWith(path + '/')
    }

    // 🚧 Tunda render sampai profil siap
    if (loadingProfile || !profileData) {
        return <LoadingFullscreen loading={true} />
    }

    return (
        <nav className='nav'>
            <LogoSidebar />

            <ul>
                {filteredSidebar.map((item) => (
                    <li key={item.id}>
                        {item.text === 'Logout' ? (
                            <a onClick={logoutHanlder} className={location.pathname === '/login' ? 'active-sidebar' : ''}>
                                <img src={loginLogoGrey} alt="logout" /> Logout
                            </a>
                        ) : (
                            <NavLink
                                to={item.tabbarPath || item.path}
                                className={isActiveRoute(item.path) ? 'active-sidebar' : ''}
                            >
                                <img
                                    src={item.img}
                                    className={`img ${isActiveRoute(item.path) ? 'active' : ''}`}
                                    alt={item.text}
                                />
                                {item.text}
                            </NavLink>
                        )}
                    </li>
                ))}
            </ul>

            <LoadingFullscreen loading={loading} />
        </nav>
    )
}

export default React.memo(Sidebar)
